import React from 'react';
import { HeaderSection } from '../common/headers/HeaderSection';
import { SectionContainerDark } from '../common/sections/SectionContainerDark';
import { TestimonyCarousel } from './testimony/TestimonyCarousel';
import { BubbleChatList } from './testimony/BubbleChatList';

export const SectionTestimony = () => {
    return (
        <SectionContainerDark id="testimony" backgroundImageUrl='img/home/maskgroup-testimony.jpeg' additionalClassName='!py-5 !my-2'>
            <HeaderSection
                title="Apa Kata Mereka"
                subtitle="Peserta yang Puas Dengan Accelist Edukasi Indonesia"
                darkMode
            />

            <div className="relative md:-mt-8">
                <TestimonyCarousel />
                <div className='-mt-10 md:-mt-12'>
                    <BubbleChatList />
                </div>
            </div>
        </SectionContainerDark>
    );
};
